<template>
    <div id="addressEdit">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">{{langText.addressAdministration}}</div>
        </nav-bar>
        <div style="background: #f6f8f7;  width: 100px; height: 10px"></div>
        <van-address-edit
                :address-info="addressInfo"
                :area-list="areaList"
                show-postal
                show-delete
                show-set-default
                show-search-result
                :search-result="searchResult"
                :area-columns-placeholder="['请选择', '请选择', '请选择']"
                @save="onSave"
                @delete="onDelete"
                @change-detail="onChangeDetail"
        />
    </div>
</template>

<script>
    import { AddressEdit, Toast, Icon } from 'vant';

    import NavBar from "@/components/common/navbar/NavBar";
    import areaData from "@/assets/js/areaData/areaData";
    import {addUserAddress, getUserAddressDetail, updateUserAddress,delUserAddress} from "@/network/mine/mine";

    import { langPackage } from "@/config/lang/addressEditLang";
    import { selectLang } from "@/config/setLanguage";

    export default {
        name: "AddressEdit",
        components: {
            [AddressEdit.name]: AddressEdit,
            [Toast.name]: Toast,
            [Icon.name]: Icon,
            NavBar: NavBar,
        },
        data() {
            return {
                areaList: areaData,
                searchResult: [],
                addressInfo: {},
                addressId: '',
                lang:"cn",
                langText:{},
                commonText:{},
            };
        },
        methods: {
            onSave(content) { //保存收货地址
                if(this.addressId == null){ //判断地址id不为空的时候
                    addUserAddress({
                        'city': content.city,
                        "defaultStatus": content.isDefault ? 1 : 0,
                        "detailAddress": content.addressDetail,
                        "name": content.name,
                        "phoneNumber": content.tel,
                        "postCode": content.postalCode,
                        "province": content.province,
                        "region": content.county
                    }).then(res => {
                        //如何是没有地址 并且在下单界面 则添加完毕之后 套转到订单
                        if (this.$route.query.lastSource == 'noSubmitOrder'){
                            this.$router.back(-1);
                        }else {
                            let status = this.$route.query.status;
                            this.$router.push({ path: '/mine/addressList', query: {lastSource: status}})
                        }
                    })//end
                }else {
                    //更改地址
                    updateUserAddress({
                        'city': content.city,
                        "defaultStatus": content.isDefault ? 1 : 0,
                        "detailAddress": content.addressDetail,
                        "name": content.name,
                        "id": this.addressId,
                        "phoneNumber": content.tel,
                        "postCode": content.postalCode,
                        "province": content.province,
                        "region": content.county
                    }).then(res => {
                            let status = this.$route.query.status;
                            this.$router.push({path: '/mine/addressList', query: {lastSource: status}})

                    });
                }
            },
            onDelete() {//删除收货地址
                //删除地址
                delUserAddress(this.addressId).then(res => {
                    Toast(res.message);
                    this.$router.push({path: '/mine/addressList'})
                })
            },
            onChangeDetail(val) {
                // //发送网络请求
                // if (val) {
                //     this.searchResult = [
                //         {
                //             name: '黄龙万科中心',
                //             address: '杭州市西湖区',
                //         },
                //     ];
                // } else {
                //     this.searchResult = [];
                // }
            },
            getParams(){
                // 取到路由带过来的参数
                this.addressId = this.$route.query.id;
                if(this.addressId == null){
                    return;
                }
                let provinceCode = 0;
                let cityCode = 0;
                let countyCode = 0;
                getUserAddressDetail(this.addressId).then( res => {
                    for(let [k, v] of Object.entries(this.areaList)) {
                        for (let [key, value] of Object.entries(v)){
                            if(k == 'province_list' && value == res.data.province) {
                                provinceCode = key
                            }
                            if(k == 'city_list' && value == res.data.city) {
                                cityCode = key
                            }
                            if(k == 'county_list' && value == res.data.region) {
                                countyCode = key
                            }
                        }
                    }
                    this.addressInfo = {
                        id: res.data.id,
                        name: res.data.name,
                        tel: res.data.phoneNumber,
                        province: provinceCode,
                        city: cityCode,
                        county: countyCode,
                        addressDetail: res.data.detailAddress,
                        areaCode: countyCode,
                        postalCode: res.data.postCode,
                        isDefault: res.data.defaultStatus ? true : false
                    }
                })
            },
            goBack(){ //返回上一级
                if (this.$route.query.lastSource == 'noSubmitOrder'){
                    this.$router.back(-1);
                }else {
                    this.$router.push({ path: '/mine/addressList'});
                }

            }
        },
        mounted() {
            this.getParams()
        },
        created() {
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });

        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    #addressEdit{
        background: #f6f8f7;
        /*height: 800px;*/
        width: 100%;
    }

    .van-address-edit {
        margin-top: 55px;
    }
    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,.5);
        background-color: #ffffff;
    }

</style>
